export default __webpack_public_path__ + "static/media/icon-machine-details.8dbf0044.svg";